// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3f29a513","937":"9f17d4c9"}[chunkId] + ".chunk.js";
};